import { SelectItem, NativeSelectProps } from "@mantine/core";

export function normaliseValue(
  data: SelectItem[],
  defaultValue: NativeSelectProps["defaultValue"],
): NativeSelectProps["defaultValue"] {
  const foundDefaultValue = data.find(
    ({ label, value }) => label === defaultValue || value === defaultValue,
  );

  return foundDefaultValue?.value || defaultValue || undefined;
}
